import React from "react";

const CancellationPolicy = () => {
  return (
    <div className="text-white margin container">
      <h1 className="text-white text-[1.5rem] font-[900] text-center">
        Cancellation & Refund Policy
      </h1>
      <p className="text-white md:mx-40 mt-10">
        <span className="text-xl font-[600]">Rescheduling Policy</span>
        <br /> <br />
        Rescheduling of a booked session is accommodated on a case by case
        basis, subject to mentor availability and scheduling constraints. Please
        share your rescheduling requests at least 24-hours in advance on our
        email offcampus.careers@gmail.com.
        <br /> <br />
        <span className="text-xl font-[600]">
          Cancellations & Return policy
        </span>
        <br /> <br />
        Sessions: We are unable to allow cancellations and refunds once the
        session is booked, but in case of an extenuating circumstance, we will
        review the request on a case by case basis and provide a resolution, if
        possible. Write to us at offcampus.careers@gmail.com.
        <br /> <br />
        Courses & others: Any educational course once purchased cannot be
        returned or refunded. Any digital/downloadable product, software, or any
        physical product is a non-returnable item as per our policy.
        <br /> <br />
        <span className="text-xl font-[600]">
          Refund Policy for expired sessions
        </span>
        <br /> <br />
        No refund is allowed once a session timing is complete. This also
        applies to late shows, no-shows and absentees. A no-show/absentee is
        when a customer misses an appointment without an approved request for
        reschedule, refund or cancellation. A late-show is when a customer does
        not join the assigned meeting link within the first 5 minutes of an
        appointment without an approved request for reschedule, refund or
        cancellation.
        <br /> <br />
        All decisions for refunds, cancellations and rescheduling are up to the
        discretion of the mentor and Off-Campus. All decisions made by
        Off-Campus are final and binding.
        <br /> <br />
        If you are approved for cancellation or return, then your refund will be
        processed, and a credit will automatically be applied to your credit
        card or original method of payment, within a certain amount of days. If
        you haven’t received a refund yet, first check your bank account again.
        Then contact your credit card company, it may take some time before your
        refund is officially posted. Next, contact your bank. There is often
        some processing time before a refund is posted. If you’ve done all of
        this and you still have not received your refund yet, please raise a
        request on the support page and we will resolve the issue asap.
        <br /> <br />
        This page is a part of our Terms of Service. You can read the full{" "}
        <a href="/terms-of-service" className="text-blue-300">
          Terms of Service
        </a>{" "}
        here.
      </p>
    </div>
  );
};

export default CancellationPolicy;
